/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import { initializeApollo } from 'gql/client'
import { NextWrapper } from 'data-fetching-wrapper'
import { CategoriaDocument, PaginaDocument } from '@gql/graphql'
import ProdottiListingHubTemplate from '@components/templates/ProdottiListingHubTemplate/ProdottiListingHubTemplate'
import ProdottiListingTemplate from '@components/templates/ProdottiListingTemplate/ProdottiListingTemplate'
import { ListingCategoriaDocument } from '@gql/graphql-get'
import { grapheneGet } from 'utils'
import { print } from 'graphql'
import ConfrontaProdottiTemplate from '@components/templates/ConfrontaProdottiTemplate/ConfrontaProdottiTemplate'

const CategoriaListing = ({ pagina, listing, categoria, isComparatore }) => {
  if (isComparatore) return <ConfrontaProdottiTemplate pagina={pagina} categoria={categoria} />

  if (categoria.depth === 1 || categoria.template === 'sottocategorie.html')
    return <ProdottiListingHubTemplate categoria={categoria} pagina={pagina} />

  return <ProdottiListingTemplate pagina={pagina} categoria={categoria} listing={listing} />
}

export const getStaticPaths = NextWrapper.getStaticPaths(
  async () => ({
    paths: [],
    fallback: 'blocking',
  }),
  '/c/[params]'
)

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ params: { params }, preview, previewData, locale }) => {
    const client = initializeApollo(locale)

    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const keys = ['p']

    const extractedParams = {}

    if (params) {
      const paramsArray = [...params]

      keys.forEach((key) => {
        const keyIndex = paramsArray.indexOf(key)
        if (keyIndex !== -1 && keyIndex < paramsArray.length - 1) {
          extractedParams[key] = paramsArray[keyIndex + 1]
          paramsArray.splice(keyIndex, 2)
        }
      })

      params = paramsArray
    }

    let isComparatore = false
    let pathParams = params

    if (params === undefined) {
      return {
        notFound: true,
      }
    }

    if (params.includes('compare')) {
      isComparatore = true
      pathParams = params.filter((x) => x !== 'compare')
    }

    const path = pathParams.join('/')

    let {
      data: { categoria },
    } = await client.query({
      query: CategoriaDocument,
      variables: { path, preview },
      context: {
        headers,
      },
    })

    if (!categoria) {
      return {
        notFound: true,
      }
    }

    let listingCategoria = null

    if (isComparatore) {
      const {
        data: { pagina },
      } = await client.query({
        query: PaginaDocument,
        variables: {
          chiave: 'comparatore',
          preview,
          contentTypeId: categoria.model,
          objectId: categoria.pk,
        },
        context: {
          headers,
        },
      })

      if (!pagina) {
        return {
          notFound: true,
        }
      }

      categoria = {
        ...categoria,
        pagina: {
          ...pagina,
          breadcrumbs: [...pagina.breadcrumbs, { label: pagina.nome, url: pagina.url }],
        },
      }
    } else if (categoria.depth > 1 && categoria.template !== 'sottocategorie.html') {
      const variables = {
        params: extractedParams,
        categoriaId: categoria.pk,
      }

      const encodedVariables = encodeURIComponent(JSON.stringify(variables))
      const encodedQuery = encodeURIComponent(print(ListingCategoriaDocument))

      const response = await grapheneGet.get(
        `?lang=${locale}&query=${encodedQuery}&operationName=ListingCategoria&variables=${encodedVariables}`
      )
      const { data } = response.data

      listingCategoria = data?.listingCategoria

      if (!listingCategoria || listingCategoria?.elementi?.length === 0) {
        return {
          notFound: true,
        }
      }
    }

    return {
      props: {
        pagina: {
          ...categoria.pagina,
          seo: {
            ...categoria.pagina.seo,
            canonicalUrl: listingCategoria?.canonicalUrl || categoria.pagina?.seo?.canonicalUrl,
          },
        },
        listing: listingCategoria,
        categoria,
        isComparatore,
        key: categoria.pk,
      },
      revalidate: 60 * 10,
    }
  },
  '/c/[params]'
)

export default CategoriaListing
